module.exports = __webpack_public_path__ + "media/icons/breadcrumbs-arrow@2x-59580a87.png";